import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
} from "@mui/material";
import { useAlerta } from "utils/alertas";

export default function ModalSemestres({ open, onClose, carrera_id, onSemestreCreado}) {
  const [form, setForm] = useState({
    numero: "",
    nombre: "",
    carrera_id: "",
  });
  const { mostrarAlerta } = useAlerta();


  const token = sessionStorage.getItem("access_token");


  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // 💾 GUARDAR DIRECTO DESDE EL MODAL
  const handleSave = async () => {
    try {
      const formData = new FormData();

      formData.append("numero", form.numero);
      formData.append("nombre", "");
      formData.append("carrera_id", carrera_id)

      const res = await fetch(`${process.env.REACT_APP_API_URL}/registro-semestre`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: formData,
      });

      const data = await res.json();

      console.log("Guardado:", data);

      if (onSemestreCreado) {
        onSemestreCreado(); 
        setForm({
          numero: "",
          nombre: "",
          carrera_id: "",
        });
      }
      mostrarAlerta("Semestre creado correctamente","success");
      onClose(); // 🔥 cerrar solo
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Nuevo Semestre</DialogTitle>

      <DialogContent>

        <TextField
          fullWidth
          margin="normal"
          label="Número"
          name="numero"
          value={form.numero}
          onChange={handleChange}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="secondary">Cancelar</Button>
        <Button  sx={{ color: "#fff" }} variant="contained" onClick={handleSave}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}